import React from 'react'
import FormSF from '../../../widgets/form/FormSF'
import ButtonUI from '../../../widgets/action/ButtonUI'

const ITRCollectUI = ({context, successMsg, errorList, onSubmit, setErrorList, submitted
  }) =>
  <div>
    <div className='g_m_top_100'><b>ITR</b></div>
    <p>Please provide the username and password for your Company to download the returns from Income Tax e-portal for the last two assessment years.</p>

    <FormSF
      context={context}
      buttonLabel='Submit'
      onSubmit={onSubmit}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      busy={submitted}
    >

    </FormSF>
  </div>

export default ITRCollectUI
